import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

const getStatusDiv = (documentProp = document) => {
  if (!documentProp) {
    return;
  }

  let statusDiv = documentProp.getElementById('assistive-hint');
  if (statusDiv) {
    return statusDiv;
  }

  statusDiv = documentProp.createElement('div');
  statusDiv.setAttribute('id', 'assistive-hint');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'polite');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    clip: 'rect(0 0 0 0)',
    overflow: 'hidden',
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
};

const cleanupStatus = debounce((documentProp) => {
  getStatusDiv(documentProp).textContent = '';
}, 5000);

const setStatus = (status, documentProp) => {
  if (!status) {
    return;
  }

  const div = getStatusDiv(documentProp);
  div.textContent = status;
  cleanupStatus(documentProp);
};

const updateA11yStatus = (getA11yMessage, document) => {
  const msg = getA11yMessage();
  setStatus(msg, document);
};

/*
 * It is a custom implementation of asstive hints mechanism. It overrides downshift's implementation
 * due to the fact that some hints were interrupted by iOS VoiceOver.
 */
const useAssistiveHintsSetter = (
  getA11yMessage,
  isInitialMount,
  dependencyArray,
  assistiveMessageArgs,
  environment
) => {
  const [updateStatus] = useState(() => debounce(updateA11yStatus, 1000));
  const env = environment
    ? environment
    : typeof window === 'undefined'
    ? {}
    : // eslint-disable-next-line no-undef
      window;

  useEffect(() => {
    if (isInitialMount) {
      return;
    }

    const a11msgF = () =>
      getA11yMessage({
        ...assistiveMessageArgs,
        isInitialMount,
      });
    updateStatus(a11msgF, env.document);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencyArray, isInitialMount]);
};

export default useAssistiveHintsSetter;
